export const services = ["ems", "priority", "north", "nuvei", "payliance"];

export const webhookType = {
    PAYMENT_CLOUD: "payment_cloud_status",
    PROCESSOR: "processor_status",
    VAR_SHEET: "var_sheet",
    NOTES: "notes",
    CHARGEBACK: "chargeback",
    TRANSACTION: "transaction",
};

export const webhookTypeName = {
    payment_cloud_status: "Status Updates",
    processor_status: "Processor Updates",
    var_sheet: "VAR Sheet Updates",
    notes: "Notes",
    chargeback: "Chargeback",
    transaction: "Transaction",
};

export const file_type_options = {
    retail: "Retail",
    retail_with_tips: "Retail with Tips",
    restaurant_with_tip_adjust: "Restaurant with Tip Adjust",
};

export const package_options = {
    e_commerce_cart_plus: "E-Commerce Cart Plus",
    web_hosting_professional: "Web Hosting Professional",
    web_hosting_premier: "Web Hosting Premier",
    web_pak_professional: "WebPak Professional",
    web_pak_premier: "WebPak Premier",
    no_equipment: "No Equipment",
    premier_150: "Premier 150",
    premier_250: "Premier 250",
    premier_500: "Premier 500",
};

export const cable_length_options = {
    25: "25",
    50: "50",
    100: "100",
};

export const connectivity_options = {
    wifi: "WIFI",
    sim: "SIM",
    ip: "IP",
};

export const US_STATES = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
};

export const CANADIAN_STATES = {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NS: "Nova Scotia",
    NT: "Northwest Territories",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Québec",
    SK: "Saskatchewan",
    YT: "Yukon",
};

export const PAYCHEX_OTHER_DEFAULT_FEE = {
    setup_fee: "0.00",
  monthly_access_fee: "10.00",
  data_breach: "0",
  monthly_minimum: "0.00",
  semi_annual_tech_fee: "0",
    voice_aru: "0.60",
  batch_fee: "0.02",
    ebt_transactions: "0.15",
  avs_fee: "0.01",
  auth_transaction: "0.05",
    monthly_cellular: "25.00",
    cellular_transaction: "0.10",
    etf_fee: "0.00",
    chargeback_fee: "25.00",
    representment_fee: "25.00",
    pre_dispute_fee: "25.00",
    returned_ach_item: "25.00",
};

export const EMS_OTHER_DEFAULT_FEE = {
    setup_fee: "0.00",
    monthly_access_fee: "15.00",
    data_breach: "15.00",
    monthly_minimum: "25.00",
    semi_annual_tech_fee: "75.00",
    voice_aru: "0.60",
    batch_fee: "0.30",
    ebt_transactions: "0.75",
    avs_fee: "0.10",
    auth_transaction: "0.25",
    monthly_cellular: "25.00",
    cellular_transaction: "0.10",
    etf_fee: "595.00",
    chargeback_fee: "45.00",
    representment_fee: "45.00",
    pre_dispute_fee: "45.00",
    returned_ach_item: "25.00",
};

export const package_mapping = {
    e_commerce_cart_plus: 49.0,
    web_hosting_professional: 59.0,
    web_hosting_premier: 89.0,
    web_pak_professional: 99.0,
    web_pak_premier: 129.0,
};

export const cable_length_pricing_mapping = {
    25: 10,
    50: 20,
    100: 30,
};

export const provided_by_options = [
    {
        label: "Processor provided",
        value: "processor_provided",
    },
    {
        label: "Merchant Provided",
        value: "merchant_provided",
    },
];

export const progression_statuses = [
  // {
  //   progression_id: 0,
  //   color: "orange",
  //   name: 'Awaiting Preapp'
  // },
  {
    progression_id: 1,
    color: "orange",
    name: 'Awaiting Preapp'
  },
  {
    progression_id: 2,
    color: "orange",
    name: 'Awaiting Business Profile'
  },
  {
    progression_id: 3,
    color: "orange",
    name: 'Awaiting Pricing'
  },
  {
    progression_id: 4,
    color: "orange",
    name: 'Awaiting Pricing Confirmation'
  },
  {
    progression_id: 5,
    color: "orange",
    name: 'Awaiting For Equipments'
  },
  {
    progression_id: 6,
    color: "orange",
    name: 'Awaiting Signature Request'
  },
  {
    progression_id: 7,
    color: "#F0BE74",
    name: "Sent for Signature / Awaiting Signature"
  },
  {
    progression_id: 8,
    color: "#819FEC",
    name: "Signed-PC Review"
  },
  {
    progression_id: 9,
    color: "#7FCECE",
    name: "UW Review"
  },
  {
    progression_id: 10,
    color: "#E7B8DF",
    name: "Pended"
  },
  {
    progression_id: 11,
    color: "#44AE42",
    name: "Reserve Req"
  },
  {
    progression_id: 12,
    color: "#44AE42",
    name: "Approved"
  },
  {
    progression_id: 13,
    color: "#FFA500",
    name: 'Declined'
  },
  {
    progression_id: 14,
    color: "#660000",
    name: 'Cancelled'
  },
  {
    progression_id: 15,
    color: "#44AE42",
    name: 'App pending PC approval'
  },
  {
    progression_id: 16,
    color: "#F0BE74",
    name: 'Sent for Signature'
  },
  {
    progression_id: 17,
    color: "#F0BE74",
    name: 'PDF requested'
  },
  {
    progression_id: 18,
    color: "#F0BE74",
    name: 'Awaiting wet signature'
  },
  {
    progression_id: 19,
    color: "#7f7f7f",
    name: "Pending Prevet"
  },
  {
    progression_id: 20,
    color: "#e6e612",
    name: "Approved Prevet"
  },
  {
    progression_id: 21,
    color: "#FF0000",
    name: 'Terminated'
  },
  {
    progression_id: 22,
    color: "#0000FF",
    name: 'Support'
  },
];

export const sales_left_progression_statuses = [
  {
    name: 'Working Lead',
    value: 'working_lead',
    color: '#b6d7a8',
  },
  {
    name: 'App in Progress',
    value: 'app_in_progress',
    color: '#a2c4c9',
  },
  {
    name: 'Sent For Signature',
    value: 'sent_for_signature',
    color: '#a4c2f4',
  },
  {
    name: 'Signed',
    value: 'signed',
    color: '#b4a7d6',
  },
  {
    name: 'Pending Docs',
    value: 'pending_docs',
    color: '#ffe599',
  },
  {
    name: 'Underwriting',
    value: 'underwriting',
    color: '#ffff00',
  },
  {
    name: 'Approved',
    value: 'approved',
    color: '#34a853',
  },
  {
    name: 'Declined',
    value: 'declined',
    color: '#ea4335',
  },
  {
    name: 'Unworkable',
    value: 'unworkable',
    color: '#ff6d01',
  },
];

export const premiseTypeOptions = [
  { value: 1, label: "Commercial/Industrial" },
  { value: 2, label: "Kiosk" },
  { value: 3, label: "Mailbox" },
  { value: 4, label: "Office Building" },
  { value: 5, label: "Residential/Home Office" },
  { value: 6, label: "Retail Store Front" },
  { value: 7, label: "Mobile/On-the-Go" },
  { value: 8, label: "Website" },
];
